// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3k00p","content":"LayoutSettings_content__38PK9"};